<!-- @veltra/icons generated sha256:9b2a38771821fe67 gen:8 source:src/svg/normal/move.svg -->
<script setup lang="ts">
defineOptions({ name: 'Move' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.333"
    viewBox="0 0 24 24"
  >
    <circle cx="9" cy="12" r="1" />
    <circle cx="9" cy="5" r="1" />
    <circle cx="9" cy="19" r="1" />
    <circle cx="15" cy="12" r="1" />
    <circle cx="15" cy="5" r="1" />
    <circle cx="15" cy="19" r="1" />
  </svg>
</template>
